import React from 'react';
import classes from './TaskTracker.module.css';

const STEPS = [
    { id: 'INITIALISED', label: 'Initializing Workspace' },
    { id: 'RESEARCH_PLANNING', label: 'Formulating Strategy' },
    { id: 'RESEARCHING', label: 'Gathering Knowledge & Outlining' },
    { id: 'WRITING', label: 'Drafting & Fact-Checking Content' },
    { id: 'QA_CHECKING', label: 'Quality Assurance Review' },
    { id: 'ASSEMBLING', label: 'Rendering Presentation' }
];

const TaskTracker = ({ currentStatus, checkpoint }) => {
    // Find the index of the current status
    let activeIndex = STEPS.findIndex(step => step.id === currentStatus);

    // If status is AWAITING_HUMAN, map it back to the step it paused on
    if (activeIndex === -1) {
        if (currentStatus === 'DONE') {
            activeIndex = STEPS.length;
        } else if (currentStatus === 'AWAITING_HUMAN') {
            if (checkpoint === 'CP-2') activeIndex = 1;      // Formulating Strategy
            else if (checkpoint === 'CP-3') activeIndex = 2; // Gathering Knowledge & Outlining
            else if (checkpoint === 'CP-4') activeIndex = 4; // Quality Assurance Review
            else activeIndex = 0; // Fallback
        }
    }

    return (
        <div className={classes.trackerCard}>
            <h4 className={classes.title}>Pipeline Execution Plan</h4>
            <ul className={classes.taskList}>
                {STEPS.map((step, index) => {
                    const isCompleted = index < activeIndex || currentStatus === 'DONE';
                    const isActive = index === activeIndex && currentStatus !== 'ERROR';

                    let itemClass = classes.taskItem;
                    if (isCompleted) itemClass += ` ${classes.completed}`;
                    if (isActive) itemClass += ` ${classes.active}`;

                    return (
                        <li key={step.id} className={itemClass}>
                            <span className={classes.icon}>
                                {isCompleted ? '✓' : (isActive && currentStatus !== 'AWAITING_HUMAN' ? '⏳' : '○')}
                            </span>
                            <span className={classes.label}>{step.label}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default TaskTracker;